import React from "react"
import {Button as MaterialButton, CircularProgress, ButtonProps} from "@material-ui/core"

type Props = {
    loading?: boolean
    className?: string
    label: string
} & ButtonProps

function Button(props: Props) {
    const {loading, disabled, label, ...other} = props;

    function renderButtonLoadingIcon() {
        if (loading) {
            return <CircularProgress color="inherit" size={15}/>
        }

        return null
    }

    return (
        <MaterialButton
            {...other}
            disabled={disabled || loading}
            startIcon={renderButtonLoadingIcon()}
        >
            {label}
        </MaterialButton>
    )
}

export default Button
